import { Warning } from '@mui/icons-material';
import { Link, Stack, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatPhoneNumber } from 'react-phone-number-input';
import { GenConfirmationDialog } from './GenDialogs';

export default function ProfileVerificationCodeDialog({
  open,
  onGoBack,
  onResend,
  onVerify,
  isLoading,
  phone,
  error,
}) {
  const { t } = useTranslation('global');
  const [verificationCode, setVerificationCode] = useState('');

  return (
    <GenConfirmationDialog
      titleVariant="h4"
      title={t('phoneVerification.title')}
      subTitle={
        <>
          {t('phoneVerification.subTitle')} <b>{formatPhoneNumber(phone)}</b>
        </>
      }
      open={open}
      titleIcon={Warning}
      titleIconColor="warning"
      confirmText={t('phoneVerification.verify')}
      closeText={t('phoneVerification.edit')}
      onRefuse={onGoBack}
      onConfirm={() => onVerify(verificationCode)}
      isLoading={isLoading}
      disabled={!verificationCode}
    >
      <Stack gap={3} alignItems="center" pt={1}>
        <TextField
          type="text"
          label={t('phoneVerification.verification')}
          required={true}
          size="small"
          fullWidth={false}
          data-testid="codeInput"
          value={verificationCode}
          error={!!error}
          helperText={error}
          onChange={event => setVerificationCode(event.target.value)}
        />
        <Typography variant="body1">
          {t('phoneVerification.dontReceived')}{' '}
          <Link
            onClick={onResend}
            underline="hover"
            component="button"
            variant="body1"
          >
            {t('phoneVerification.resend')}
          </Link>
        </Typography>
      </Stack>
    </GenConfirmationDialog>
  );
}
